<template>
  <v-dialog scrollable fullscreen v-model="openResourceFull">
    <v-card>
      <v-card-title class="bgcolor-5 modal">
        <v-spacer></v-spacer>
        <i @click="setModalResourceFull({isOpen: false, resource: null})" class="icon-close"></i>
      </v-card-title>

      <main v-if="srcResource != null" id="frameResource">
        <template v-if="config.escalarRecursos">
          <div id="resizeBody">
            <iframe class="iframeIndex" frameborder="0" :src="srcResource" allowfullscreen></iframe>
          </div>
        </template>
        <template v-else>
          <iframe frameborder="0" :src="srcResource" allowfullscreen></iframe>
        </template>
        
      </main>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: "ModalResourceFull",
  methods:{
    resize(){
      
    },
    ...mapMutations(["setModalResourceFull"]) 
  },
  computed: {
    ...mapState(["srcResource", "openResourceFull", "config"]),
  }
};
</script>
<style scoped>

#resizeBody {
  position: absolute;
  min-width: 1324px;
  min-height: 768px;
  overflow: hidden;
  background-color: white;
}

.iframeIndex {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>